export enum IdentityProvider {
  Spid = 0,
  Cie = 5,
  Email = 10
}